<div class="cpcontent">
  <h2>Development Comments</h2>
  <ul>
    <li>Implement Oxygen Calculation</li>
    <li>Add pictures to description</li>
    <li>Get correct domain names</li>
    <li>try various moving averages</li>
    <li>select new center: change mouse to pointer</li>
    <li>add phone simulator in config for GPS and Beacon</li>
    <li>Review default sensor tab</li>
    <li>Save description should save the description</li>
    <li>Remove save column in sensors tab</li>
    <li>Define radio button for new scenario</li>
    <li>Error for scenario wizard should be on the wizerd</li>
    <li>use word Exposure</li>
  </ul>
  <ul>
    <li class="green">Done -- use feet</li>
    <li class="green">Done -- Implement Alarm</li>
    <li class="green">Done -- change QR code to remove the scenario id</li>
    <li class="green">Done -- put log into scenario</li>
    <li class="green">Done -- reinit grpah in gps log within page</li>
    <li class="green">Done -- walk with map the accuracy does not work</li>
    <li class="green">Done -- english instructions</li>
    <li class="green">Done -- start with standard sensor list</li>
    <li class="green">Done -- GPS Sensor does not responsive correctly</li>
    <li class="green">Done -- Generic headings for Scenario Editor</li>
    <li class="green">Done --Beacon: Create new scenario, create wizard</li>
    <li class="green">Done -- in description put save button on top, make edit button invisible during edit</li>
    <li class="green">Done -- make gps/beacon radio in wizard and fix tab visibility</li>
    <li class="green">Not Done, but instructions -- leave description blank, but offer to copy from other scenario</li>
    <li class="green">Done -- pic should have a heading, use two columns, better explanation, make axis bold, repositionn points, center x-axis description</li>
    <li class="green">Done -- find beacons</li>
    <li class="green">Done -- add instruction on tabs</li>
    <li class="green">Done -- hide form until edit or add</li>
    <li class="green">Done -- pull downs should have arrows + text select one</li>
    <li class="green">Done -- alarm threshold</li>
    <li class="green">dummy value should be</li>
    <li class="green">Done -- add response to add button</li>
    <li class="green">Done -- values are just examples</li>
    <li class="green">Done -- Delete scenarios</li>
    <li class="green">Done -- How can we prevent new scenarios</li>
    <li class="green">Done -- create default values for all sensors and populate</li>
    <li class="green">Done -- rename threshold to alarm threshold</li>
    <li class="green">Done -- Configure a new beacon and sensors</li>
    <li class="green">Done -- Add note to test and tell how.</li>
    <li class="green">Done -- Change name of instructions to "Edit Scenario Help", "Edit Beacon Config Help" etc</li>
    <li class="green">Done -- Create instructions how to find and download the app</li>
    <li class="green">Done -- collapse save buttons into one</li>
    <li class="green">Done -- alarm, for GPS</li>
    <li class="green">Done -- add logs to scenario</li>
    <li class="green">Done -- in scenariolist autorefrseh after delete</li>
    <li class="green">Done -- prevent scenario with same name or empty name</li>
    <li class="green">Done -- beacon log list by scenarioid</li>
    <li class="green">Done -- Axis description, add far and close in y-axis</li>
    <li class="green">Done -- And plot distance</li>
    <li class="green">Done -- revert sequence of sensors in display</li>
    <li class="green">Done -- GPS: create scenario</li>
    <li class="green">Done -- intructions have to say what to do next</li>
  </ul>
</div>